/**
 * @file        src/pages/hotel/CorporateBookingList.jsx
 * @description Corporate Hotel → Booking List. Same list/filters/actions as
 *              the B2C Hotel Booking List (BookingList.jsx), fixed to
 *              audience=b2b, instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-07-27
 * @changelog
 *   - 2026-07-27 Claude — Initial (Corporate Hotel booking visibility).
 *   - 2026-08-04 Claude — Agent retirement (CR E8): the commission column was
 *                          removed from BookingList.jsx; updated the
 *                          description accordingly.
 */
import BookingList from './BookingList';

export default function CorporateBookingList() {
  return (
    <BookingList
      title="Corporate Booking List"
      subtitle="Corporate Hotel · hotel bookings"
      audience="b2b"
    />
  );
}
